import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7356c7af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task__popover-title" }

import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '../../../models';
import { PropType } from 'vue';
import { TaskCardItemWrapper } from './';
import {
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmIconView,
  TirPmPopover,
  TirPmTooltipElement,
} from 'tir-components';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-author',
  props: {
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TaskCardItemWrapper), { element: __props.element }, {
    default: _withCtx(() => [
      _createVNode(_unref(TirPmTooltipElement), null, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(__props.task.Author.FirstName) + " " + _toDisplayString(__props.task.Author.MiddleName) + " " + _toDisplayString(__props.task.Author.LastName), 1)
        ]),
        default: _withCtx(() => [
          (__props.task.Author)
            ? (_openBlock(), _createBlock(_unref(TirPmIconView), {
                key: 0,
                size: 24,
                isRounded: "",
                colorCode: __props.task.Author.NoPhotoColor,
                isBordered: false,
                imageLoadUrl: __props.task.Author.ImageUrl
              }, {
                mainSlot: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.task.Author.FirstName[0] + __props.task.Author.LastName[0]), 1)
                ]),
                _: 1
              }, 8, ["colorCode", "imageLoadUrl"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["element"]))
}
}

})